var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n  ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 892.72,
    cy: 1499.8098,
    r: 800,
    gradientTransform: "matrix(1.5625 0 0 -1.5625 -844.5 3043.2029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7937"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    style: {
      stopColor: "#EA7839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    style: {
      stopColor: "#DF773D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D57641"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.1,0h1481.9c280,0,509.1,229.1,509.1,509.1v1481.9c0,280-229.1,509.1-509.1,509.1H509.1C229.1,2500,0,2270.9,0,1990.9V509.1C0,229.1,229.1,0,509.1,0L509.1,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1960.3,430.2l-38.4,103.4l-19.6,50.8c-148.7,380.7-264.3,561.4-387.2,561.4c-70.8,0-112.8-21.2-167-70.8l-15.7-14.7c-39.1-37.3-55.5-46.5-93.1-46.5c-19.6,0-54.6,26-98.9,86.5c-46,62.8-96.4,155.6-150.6,277.8l-5,11.4l527.4,0l-65.7,140.9H953.9v578.6H809.2v-1679L1960.3,430.2L1960.3,430.2z M1755.1,571.2l-801.2-0.1v559.6c96-172.2,187.2-258.7,285.3-258.7c76.3,0,121.2,22.2,178,73.9l16.2,15.2c36.5,34.8,50.5,42.8,81.6,42.8C1549.4,1003.9,1640.6,854.3,1755.1,571.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontier);
export default __webpack_public_path__ + "static/media/frontier.d793f29603bfce1856c15eb576e71965.svg";
export { ForwardRef as ReactComponent };